import React, { useState, Fragment, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormGroup, FormControlLabel, RadioGroup, Radio, TextField } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import c from 'classnames';
// import InfoLarge from '../../Analytics/assets/DisclaimerWarning1.svg';

import { getBenchmarkString, getData, getFlagpoleBmPayloadFromBenchmarks } from '../../../utils/functions';
import SelectMenu from '../../Diagnose/BenchmarkBoard/SelectMenu';
import { getStaticText } from '../../../utils/constants';
import { getReportDynamicTextInfo, getPsOhiExLabel, isPsOhiOhiReport } from '../reportPublicSector';
import getStaticTextDiagnose from '../../Diagnose/constants';
import InfoLarge from '../../Analytics/assets/DisclaimerWarning1.svg';

function FlagPole({
    leftBenchmarks,
    updateLeftBenchmarks,
    updateRightBenchmarks,
    rightBenchmarks,
    goBack,
    submitReport,
    reportApiParams,
    reportIndex,
    defaultSettings,
    scoreData,
    reportError,
    isCfgClient,
    isNonProfit,
    isIngClient,
    setLastMenu,
    exLeftBenchmarks,
    exRightBenchmarks,
    // updateExRightBenchmarks,
    // updateExLeftBenchmarks,
    compYrSettings,
    compType,
}) {
    const {
        lang,
        resurvey_settings,
        ohi_text,
        survey_version,
        apply_employee_exp_benchmark = false,
        statistical_significance_calc_ohi: sigVersion,
        report_type,
        role,
        is_public_sector_ohi = false,
    } = defaultSettings;

    const { comparison_type = '1' } = compType;
    const staticTextDiagnose = getStaticTextDiagnose(lang);
    const { QUARTILE_RESURVEY } = staticTextDiagnose;
    const staticText = getStaticText(lang);
    const { SITE_TEXT, USER_ROLES } = staticText;
    const { ADMIN, SUPER_ADMIN } = USER_ROLES;
    const isAdmin = role && (role === SUPER_ADMIN || role === ADMIN);

    const {
        SUB_INFO,
        PRACTICE_RANKING,
        CHART_PRACTICE_RANKING,
        CHART_PRACTICE_RANKING_BUBBLES,
        SET_FLAGPOLE_CHART,
        SUB_INFO_PRACTICE,
        DISPLAY_TORNADO_CHART,
        BACK,
        SELECT_PRIORITY_PRACTICE,
        CREATE_REPORT,
        SELECT_COMPARISON_BUBBLES,
        DYNAMIC_TEXT_INFO,
        COMPARISON_BUBBLES,
        COMPARISON_BUBBLES_V2,
        RESURVEY_DOWNLOAD_TYPE,
        SELECT_RESURVEY_DOWNLOAD_TYPE,
        COMPARISON_BUBBLE,
        FLAGPOLE_CHART,
        PRACTICE_SCREEN,
        CATEGORY_BASED,
        SELECT_COMPARISON_BUBBLES_EX,
        // SET_EE_FLAGPOLE_CHART,
        // SUB_INFO_EX_FLAGOLE,
        // EX_BM_NOT_AVL2,
        // EX_BM_NOT_AVL3,
        COMPARISON_BUBBLE_NO_BM,
        COMPARISON_BUBBLE_BOTH_NO_BM,
        ADDITIONAL_PRACTICES,
    } = SITE_TEXT || {};
    const comparisonBubbleList = sigVersion === 'v2' ? COMPARISON_BUBBLES_V2 : COMPARISON_BUBBLES;
    const dynamicComparisonBubbleList = isAdmin
        ? comparisonBubbleList
        : comparisonBubbleList.filter(({ key }) => key !== '5');

    const { key: eeComparisonType } =
        dynamicComparisonBubbleList.find(({ list_key }) => list_key.toLowerCase() === comparison_type?.toLowerCase()) ||
        {};

    const { REPORT_TYPE } = getReportDynamicTextInfo(DYNAMIC_TEXT_INFO, { ohi_text, is_public_sector_ohi });
    const priorityPractices = useMemo(() => {
        const mainArr = [];
        const { qbyq = {} } = scoreData;
        const { records = {} } = qbyq;
        const { ohi_score, ...dataToIterate } = records;
        Object.keys(dataToIterate).forEach(innerContent => {
            const { children = {} } = dataToIterate[innerContent];
            Object.keys(children).forEach(childSet => {
                const { display_name: label } = children[childSet];
                mainArr.push({
                    label,
                    value: childSet,
                });
            });
        });
        return mainArr;
    }, [scoreData]);

    const {
        bm_filters: bmFilter,
        need_tornado_chart: tornado_chart,
        options: opt,
        comparisonBubble: cmpBubble,
        resurveyDownloadType: resurveyOldDownloadType,
        practices: practiceArr,
        falgpole_deep_dive: flagpoleDeepDive,
        customDeltaValue: customValue,
        eeCompBubble: eeCmpBubble = '1',
        eeCustomDeltaValue: eeCustomValue,
    } = reportApiParams;
    const { ReportType } = opt;
    const mapPsOhiEx = text => getPsOhiExLabel(is_public_sector_ohi, ReportType, text, ADDITIONAL_PRACTICES);
    const hidePsOhiFlagpoleCategory = isPsOhiOhiReport(is_public_sector_ohi, ReportType);
    const { compYrSettings: settings = {}, settingsFetched = false } = compYrSettings.compYr0 || {};
    const { apply_employee_exp_benchmark: compYrApplyExBm = false } = settings || {};
    const [customDeltaVal, setCustomDeltaValue] = useState('');
    const [eeCustomDeltaVal, setEECustomDeltaValue] = useState('');

    const compBubbleOriginal = resurvey_settings.toLowerCase() === QUARTILE_RESURVEY ? 2 : 1;
    // const eeCompBubbleOriginal = resurvey_settings.toLowerCase() === QUARTILE_RESURVEY ? 2 : 1;

    const [flagPoleData, setFlagPoleData] = useState({
        bm_filters: bmFilter || [],
        practices: practiceArr || [],
        need_tornado_chart: tornado_chart || false,
        ex_bm_filters: apply_employee_exp_benchmark
            ? [getBenchmarkString(exLeftBenchmarks), getBenchmarkString(exRightBenchmarks)]
            : [],
        options: opt || {
            flagpole_footer: [
                {
                    bmcode: '',
                    bmtext: '',
                },
                {
                    bmcode: '',
                    bmtext: '',
                },
            ],
        },
        comparisonBubble: cmpBubble || `${compBubbleOriginal}`,
        resurveyDownloadType: resurveyOldDownloadType,
        falgpole_deep_dive: hidePsOhiFlagpoleCategory ? '0' : flagpoleDeepDive || '0',
        customDeltaValue: customValue || `${customDeltaVal}`,
        eeCompBubble: eeComparisonType,
        eeCustomDeltaValue: eeCustomValue || `${eeCustomDeltaVal}`,
    });

    const {
        bm_filters,
        need_tornado_chart,
        comparisonBubble,
        practices,
        resurveyDownloadType,
        falgpole_deep_dive,
        customDeltaValue,
        eeCompBubble,
        eeCustomDeltaValue,
    } = flagPoleData;
    const isActive = ReportType === '3' ? comparisonBubble : bm_filters.length > 0;

    useEffect(() => {
        const synced = getFlagpoleBmPayloadFromBenchmarks(leftBenchmarks, rightBenchmarks);
        if (!synced) {
            return;
        }
        const { bm_filters_arr: syncedBmFilters = [], footer_arr: syncedFooter = [] } = synced;
        const bmMatches =
            syncedBmFilters.length === bm_filters.length &&
            syncedBmFilters.every((value, index) => value === bm_filters[index]);
        if (bmMatches) {
            return;
        }
        setFlagPoleData(prev => ({
            ...prev,
            bm_filters: syncedBmFilters,
            options: {
                ...prev.options,
                flagpole_footer: syncedFooter,
            },
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leftBenchmarks, rightBenchmarks]);

    const isV4 = survey_version === '4' || survey_version === '3_2';
    const [error, setError] = useState('');
    const [empExpError, setEmpExpError] = useState('');
    const showCustomDelta = comparisonBubble === '3';
    const showEECustomDelta = eeCompBubble === '3';
    const filteredComparisonBubbleList = dynamicComparisonBubbleList.filter(({ key }) => {
        if (sigVersion === 'v2') {
            if (!apply_employee_exp_benchmark || (settingsFetched && !compYrApplyExBm)) {
                // Exclude keys '2',
                return key !== '2';
            }
            // Exclude empty keys
            return key !== '';
        }
        if (!apply_employee_exp_benchmark || (settingsFetched && !compYrApplyExBm)) {
            // Exclude key '2'
            return key !== '2';
        }
        // Exclude empty keys
        return key !== '';
    });

    const handleFlagPoleData = ({ name, value }) => {
        const cloneObj = { ...flagPoleData };
        if (name === 'need_tornado_chart') {
            cloneObj[name] = !need_tornado_chart;
        } else {
            cloneObj[name] = value;
        }
        setFlagPoleData(cloneObj);
    };

    const handleCustomData = val => {
        const { name, value } = val;
        const newValue = value;
        if (newValue === '' || /^[0-9\b]+$/.test(newValue)) {
            const numValue = parseInt(newValue, 10);
            if (numValue < 0 || numValue > 99) {
                if (name === 'customDeltaValue') {
                    setError('Value must be between 0 to 99');
                } else if (name === 'eeCustomDeltaValue') {
                    setEmpExpError('Value must be between 0 to 99');
                }
            } else {
                setError('');
                setEmpExpError('');
            }
        }
        if (name === 'customDeltaValue') {
            setCustomDeltaValue(newValue);
        } else if (name === 'eeCustomDeltaValue') {
            setEECustomDeltaValue(newValue);
        }
        const cloneObj = { ...flagPoleData };
        cloneObj[name] = newValue || '';
        setFlagPoleData(cloneObj);
    };

    const getSelectedChild = (item, control) => {
        const { code = '', selectedOption = '' } = item;
        const cloneObj = cloneDeep(flagPoleData);
        const { footer_arr = [], bm_filters_arr = [] } =
            control === 'left'
                ? getData(control, rightBenchmarks, leftBenchmarks, selectedOption, code)
                : getData(control, leftBenchmarks, rightBenchmarks, selectedOption, code);
        cloneObj.options.flagpole_footer = footer_arr;
        cloneObj.bm_filters = bm_filters_arr;
        setFlagPoleData(cloneObj);
    };

    // const getExSelectedChild = (item, control) => {
    //     const { code = '', selectedOption = '' } = item;
    //     const cloneObj = cloneDeep(flagPoleData);
    //     const { footer_arr, bm_filters_arr = [] } =
    //         control === 'left'
    //             ? getData(control, exRightBenchmarks, exLeftBenchmarks, selectedOption, code)
    //             : getData(control, exLeftBenchmarks, exRightBenchmarks, selectedOption, code);
    //     cloneObj.options.ex_flagpole_footer = footer_arr;
    //     cloneObj.ex_bm_filters = bm_filters_arr;
    //     setFlagPoleData(cloneObj);
    // };

    const handlePriortyPractice = ({ value }) => {
        const { practices: priortyPractices } = flagPoleData;
        const index = priortyPractices.indexOf(value);
        if (index > -1) {
            priortyPractices.splice(index, 1);
        } else {
            priortyPractices.push(value);
        }
        setFlagPoleData({ ...flagPoleData, practices: priortyPractices });
    };

    const getWarningText = () => {
        if (apply_employee_exp_benchmark && !compYrApplyExBm && report_type?.toLowerCase() === 'percentile') {
            return COMPARISON_BUBBLE_NO_BM;
        }

        if (!apply_employee_exp_benchmark && !compYrApplyExBm && report_type?.toLowerCase() === 'percentile') {
            return COMPARISON_BUBBLE_BOTH_NO_BM;
        }
        return null;
    };

    const bmWarningText = getWarningText();

    const handleNext = () => {
        const practice = priorityPractices.filter(({ value }) => !practices.includes(value));
        let priorityPractice = '';
        if (practice.length !== priorityPractices.length) {
            priorityPractice = practice.map(({ value }) => value).join('$');
        } else {
            priorityPractice = 'DELETE';
        }
        submitReport({
            ...flagPoleData,
            ...(hidePsOhiFlagpoleCategory && { falgpole_deep_dive: '0' }),
            priorityPractice,
            bm_filters,
        });
    };

    const renderRadioOptions = () => {
        if (!(survey_version === '4' || survey_version === '3_2')) return null;
        if (!(ReportType === '0' || ReportType === '1' || ReportType === '3')) return null;
        return (
            <div className="heatmapPlacement">
                <div className="headerTitle">{FLAGPOLE_CHART}</div>
                <div className="reportWrapper viewContent">
                    <FormGroup data-test-id="comparisonBubble" classes={{ root: 'radioGroup' }}>
                        <RadioGroup
                            aria-label="non_profit_report_full"
                            name="falgpole_deep_dive"
                            value={falgpole_deep_dive}
                            onChange={({ target }) => handleFlagPoleData(target)}
                            className="outComeVersion"
                        >
                            {[
                                { title: PRACTICE_SCREEN, key: '0' },
                                {
                                    title: CATEGORY_BASED,
                                    key: '1',
                                },
                            ]
                                .filter(({ key }) => !(hidePsOhiFlagpoleCategory && key === '1'))
                                .map(({ title, key }) => (
                                    <div className="outcomeContent" key={key}>
                                        <FormControlLabel
                                            key={key}
                                            value={key}
                                            control={<Radio disableRipple />}
                                            label={title}
                                            className="outcomeText"
                                        />
                                    </div>
                                ))}
                        </RadioGroup>
                    </FormGroup>
                    {/* <span className="sampleText" onClick={() => handleShowPractice()}>
                            <img src={viewIcon} alt="" />
                            {VIEW_SAMPLE_SLIDE}
                        </span> */}
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (isActive) {
            setLastMenu(true);
        } else {
            setLastMenu(false);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <section className="flagPoleSection">
            <div className="flagPoleHeader">
                <h2>{REPORT_TYPE[reportIndex]} - </h2>
                {!isV4 && (
                    <h2 className="subHeading">
                        {ReportType === '3' ? CHART_PRACTICE_RANKING_BUBBLES : CHART_PRACTICE_RANKING}
                    </h2>
                )}
                {isV4 && (
                    <h2 className="subHeading">{ReportType === '3' ? COMPARISON_BUBBLE : CHART_PRACTICE_RANKING}</h2>
                )}
            </div>
            {ReportType === '3' ? (
                <div className="enterpriseWrapper">
                    {isCfgClient || isIngClient || isV4 ? null : (
                        <div>
                            <div className="title">{SELECT_PRIORITY_PRACTICE}</div>
                            <FormGroup classes={{ root: c('enterpriseCheckBox') }} row>
                                {priorityPractices.map(({ label, value }) => (
                                    <FormControlLabel
                                        key={label}
                                        classes={{
                                            root: c({ enterpriseLabel: practices.indexOf(value) > -1 }),
                                        }}
                                        control={
                                            <Checkbox
                                                checked={practices.indexOf(value) > -1}
                                                value={value}
                                                name={label}
                                                disabled={practices.length === 15 && practices.indexOf(value) === -1}
                                                onChange={({ target }) => handlePriortyPractice(target)}
                                                disableRipple
                                            />
                                        }
                                        label={label}
                                    />
                                ))}
                            </FormGroup>
                        </div>
                    )}
                    <div className={c('bubbleWrapper', { isCfgClient })}>
                        <div className="title"> {SELECT_COMPARISON_BUBBLES}</div>
                        <FormGroup data-test-id="comparisonBubble" classes={{ root: 'radioGroup' }}>
                            <RadioGroup
                                aria-label="comparisonBubble"
                                name="comparisonBubble"
                                value={comparisonBubble}
                                onChange={({ target }) => handleFlagPoleData(target)}
                            >
                                {dynamicComparisonBubbleList.map(({ label, key }, i) => (
                                    <FormControlLabel
                                        key={i}
                                        value={key}
                                        control={<Radio disableRipple />}
                                        label={label}
                                    />
                                ))}
                            </RadioGroup>
                        </FormGroup>
                    </div>

                    {showCustomDelta ? (
                        <div className="customReportDeltaContent">
                            <TextField
                                value={customDeltaValue}
                                name="customDeltaValue"
                                placeholder="Enter custom value(n)"
                                onChange={({ target }) => handleCustomData(target)}
                                error={!!error}
                                helperText={error}
                                fullWidth
                                className="select"
                                variant="outlined"
                            />
                        </div>
                    ) : null}

                    <div className={c('bubbleWrapper', { isCfgClient })}>
                        <div className="title">{mapPsOhiEx(SELECT_COMPARISON_BUBBLES_EX)}</div>
                        <FormGroup data-test-id="comparisonBubble" classes={{ root: 'radioGroup' }}>
                            <RadioGroup
                                aria-label="comparisonBubble"
                                name="eeCompBubble"
                                value={eeCompBubble}
                                onChange={({ target }) => handleFlagPoleData(target)}
                            >
                                {filteredComparisonBubbleList.map(({ label, key }, i) => (
                                    <FormControlLabel
                                        key={i}
                                        value={key}
                                        control={<Radio disableRipple />}
                                        label={label}
                                    />
                                ))}
                            </RadioGroup>
                            <div>
                                {bmWarningText !== null && (
                                    <div className="noMapDemo exInfo">
                                        <span>
                                            <img src={InfoLarge} alt="warning" />
                                        </span>
                                        {getWarningText()}
                                    </div>
                                )}
                            </div>
                        </FormGroup>
                        {/* {settingsFetched && !compYrApplyExBm ? (
                            <div className="noMapDemo exInfo">
                                <span>
                                    <img src={InfoLarge} alt="warning" />
                                </span>
                                {EX_BM_NOT_AVL2}
                            </div>
                        ) : null} */}
                        {/* {!apply_employee_exp_benchmark ? (
                            <div className="noMapDemo exInfo">
                                <span>
                                    <img src={InfoLarge} alt="warning" />
                                </span>
                                {EX_BM_NOT_AVL3}
                            </div>
                        ) : null} */}
                    </div>

                    {showEECustomDelta ? (
                        <div className="customReportDeltaContent">
                            <TextField
                                value={eeCustomDeltaValue}
                                name="eeCustomDeltaValue"
                                placeholder="Enter custom value(n)"
                                onChange={({ target }) => handleCustomData(target)}
                                error={!!empExpError}
                                helperText={empExpError}
                                fullWidth
                                className="select"
                                variant="outlined"
                            />
                        </div>
                    ) : null}

                    {isCfgClient && (
                        <div className="bubbleWrapper">
                            <div className="title"> {SELECT_RESURVEY_DOWNLOAD_TYPE}</div>
                            <FormGroup data-test-id="resurveyDownloadType" classes={{ root: 'radioGroup' }}>
                                <RadioGroup
                                    aria-label="resurveyDownloadType"
                                    name="resurveyDownloadType"
                                    value={resurveyDownloadType}
                                    onChange={({ target }) => handleFlagPoleData(target)}
                                >
                                    {RESURVEY_DOWNLOAD_TYPE.map(({ label, key }, i) => (
                                        <FormControlLabel
                                            key={i}
                                            value={key}
                                            control={<Radio disableRipple />}
                                            label={label}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormGroup>
                        </div>
                    )}
                    {reportError && <div className="errorInfo">{reportError}</div>}
                </div>
            ) : null}
            {ReportType < 3 ? (
                <Fragment>
                    <div className="enterpriseWrapper">
                        <div className="title">{SET_FLAGPOLE_CHART}</div>
                        <div className="subInfo flagPoleInfo">{SUB_INFO}</div>
                        <div className="flagPoleSelecttWrapper clearfix">
                            <div>
                                <SelectMenu
                                    defaultSettings={defaultSettings}
                                    menuClass="reportMenu"
                                    key="left"
                                    control="left"
                                    benchmarks={leftBenchmarks}
                                    getSelectedChild={getSelectedChild}
                                    updateBenchmarks={updateLeftBenchmarks}
                                />
                            </div>
                            <div>
                                <SelectMenu
                                    defaultSettings={defaultSettings}
                                    menuClass="reportMenu"
                                    key="right"
                                    control="right"
                                    benchmarks={rightBenchmarks}
                                    getSelectedChild={getSelectedChild}
                                    updateBenchmarks={updateRightBenchmarks}
                                />
                            </div>
                        </div>
                        {renderRadioOptions()}
                        {!isNonProfit && survey_version !== '4' && (
                            <Fragment>
                                <div className="title clearfix">{PRACTICE_RANKING}</div>
                                <div className="subInfo clearfix">{SUB_INFO_PRACTICE}</div>
                                <FormGroup classes={{ root: c('enterpriseCheckBox') }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={need_tornado_chart}
                                                classes={{ root: c({ enterpriseLabel: !need_tornado_chart }) }}
                                                value={need_tornado_chart}
                                                onChange={({ target }) => handleFlagPoleData(target)}
                                                disableRipple
                                                name="need_tornado_chart"
                                            />
                                        }
                                        label={DISPLAY_TORNADO_CHART}
                                    />
                                </FormGroup>
                            </Fragment>
                        )}
                    </div>
                    {/* {apply_employee_exp_benchmark ? (
                        <div className="enterpriseWrapper">
                            <div className="title">{SET_EE_FLAGPOLE_CHART}</div>
                            <div className="subInfo flagPoleInfo">{SUB_INFO_EX_FLAGOLE}</div>
                            <div className="flagPoleSelecttWrapper clearfix">
                                <div>
                                    <SelectMenu
                                        defaultSettings={defaultSettings}
                                        menuClass="reportMenu"
                                        key="left"
                                        control="left"
                                        benchmarks={exLeftBenchmarks}
                                        getSelectedChild={getSelectedChild}
                                        updateBenchmarks={updateExLeftBenchmarks}
                                    />
                                </div>
                                <div>
                                    <SelectMenu
                                        defaultSettings={defaultSettings}
                                        menuClass="reportMenu"
                                        key="right"
                                        control="right"
                                        benchmarks={exRightBenchmarks}
                                        getSelectedChild={getExSelectedChild}
                                        updateBenchmarks={updateExRightBenchmarks}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : null} */}
                </Fragment>
            ) : null}
            <div className="buttonWrapperReports">
                <div className="outlineBtn" onClick={goBack}>
                    {BACK}
                </div>
                {/* <div className={c('blueButton', { active: isActive })} onClick={handleNext}> */}
                <div className={c('blueButton', { active: isActive })} onClick={handleNext}>
                    {CREATE_REPORT}
                </div>
            </div>
        </section>
    );
}
FlagPole.propTypes = {
    leftBenchmarks: PropTypes.array.isRequired,
    updateLeftBenchmarks: PropTypes.func.isRequired,
    updateRightBenchmarks: PropTypes.func.isRequired,
    submitReport: PropTypes.func.isRequired,
    rightBenchmarks: PropTypes.array.isRequired,
    goBack: PropTypes.func.isRequired,
    scoreData: PropTypes.object.isRequired,
    reportApiParams: PropTypes.object.isRequired,
    defaultSettings: PropTypes.object.isRequired,
    reportIndex: PropTypes.number.isRequired,
    reportError: PropTypes.string.isRequired,
    isCfgClient: PropTypes.bool.isRequired,
    isNonProfit: PropTypes.bool.isRequired,
    isIngClient: PropTypes.bool.isRequired,
    setLastMenu: PropTypes.func.isRequired,
    exLeftBenchmarks: PropTypes.array.isRequired,
    exRightBenchmarks: PropTypes.array.isRequired,
    // updateExRightBenchmarks: PropTypes.func.isRequired,
    // updateExLeftBenchmarks: PropTypes.func.isRequired,
    compYrSettings: PropTypes.object.isRequired,
    compType: PropTypes.object.isRequired,
};
export default FlagPole;
